export default __webpack_public_path__ + "static/media/i038sp.80e1ad34.webp";